import * as React from "react";
import {useLeadStore} from "../store/Lead.store";
import {observer} from "mobx-react-lite";
import {ButtonComponent} from "../../form/button.component";
import './belfius-block.component.scss'
import {LoadingComponent} from "./loading.component";
import {replaceMarker} from "../../../helpers/marker-utils";

export const BelfiusBlock = observer( () => {
    const store = useLeadStore();

    if ( !store.configuration.supportsBelfiusFinancing ) {
        return <React.Fragment/>;
    }

    let loanDuration = store.translate( 'leadgeneration.steps.order.belfius.loanDuration' );
    let monthlyRefund = store.translate( 'leadgeneration.steps.order.belfius.monthlyRefund' );
    let months = store.translate( 'leadgeneration.steps.order.belfius.months' );

    let periodicAmount = store.quoteBelfius.periodicAmount;
    let loanAmount = store.quoteBelfius.loanAmount;
    let yearlyRealRate = store.quoteBelfius.yearlyRealRate;
    let interestRate = store.quoteBelfius.interestRate;
    let totalAmount = store.quoteBelfius.totalAmount;
    let currency = store.quoteBelfius.currency;
    let jkp = store.translate( 'leadgeneration.steps.order.belfius.jkp' );
    let fixedBorrowingRate = store.translate( 'leadgeneration.steps.order.belfius.fixedBorrowingRate' );
    let totalAmountToRefund = store.translate( 'leadgeneration.steps.order.belfius.totalAmountToRefund' );
    let loanTerm = store.quoteBelfius.loanTerm;

    let paymentInfoWithMarkers = store.translate( 'leadgeneration.steps.order.belfius.paymentInfo' );
    let filledInPaymentInfo = replaceMarker( paymentInfoWithMarkers, [loanAmount as unknown as string,
                                                           loanTerm as unknown as string,
                                                           yearlyRealRate as unknown as string,
                                                           interestRate as unknown as string,
                                                           periodicAmount as unknown as string,
                                                           loanTerm as unknown as string,
                                                           totalAmount as unknown as string] );
    return (<div className={"mt-3 w-100"}>
        <LoadingComponent show={store.quoteBelfius.reloading}/>
        <div className={"row belfius-header"}>
            <h3>{store.translate( 'leadgeneration.steps.order.belfius.header' )}</h3>
        </div>
        <div className={"row belfius-content"}>
            <div className={"row belfius-logo"}>
            </div>
            <div className={"row w-100 mb-2 pb-3 pt-3 pl-3 pr-3 d-flex justify-content-between"}>
                <div className={"col-md-3 font-weight-bold"}>{loanDuration}</div>
                <div className={"col-md-3 "}>{loanTerm} {months}</div>
                <div className={"col-md-3 font-weight-bold"}>{monthlyRefund}</div>
                <div className={"col-md-3 "}>{periodicAmount} {currency}</div>
                <div className={"col-md-3 font-weight-bold"}>{jkp}</div>
                <div className={"col-md-3 "}>{yearlyRealRate}</div>
                <div className={"col-md-3 font-weight-bold"}>{fixedBorrowingRate}</div>
                <div className={"col-md-3 "}>{interestRate}</div>
                <div className={"col-md-3 font-weight-bold"}>{totalAmountToRefund}</div>
                <div className={"col-md-3 "}>{totalAmount} {currency}</div>
                <div className={"col-md-3 "}/>
                <div className={"col-md-3 "}/>
            </div>
            <div className={"row w-100 mb-2 pb-3 pt-3 pl-3 pr-3 d-flex justify-content-between"}>
                <div className={"col-md-12"}>
                    <ButtonComponent text={store.translate( 'leadgeneration.steps.order.belfius.button.interested' )}
                                     onClick={() => {
                                         if ( store != null && store.quoteBelfius != null && store.quoteBelfius.links != null ) {
                                             window.open( store.quoteBelfius.links.get( 'grant' ), '_blank' );
                                         }
                                     }}
                                     type={'primary'}
                                     disabled={false}/>
                    <ButtonComponent text={store.translate( 'leadgeneration.steps.order.belfius.button.appointment' )}
                                     onClick={() => {
                                         if ( store != null && store.quoteBelfius != null && store.quoteBelfius.links != null ) {
                                             window.open( store.quoteBelfius.links.get( 'make_appointment' ), '_blank' );
                                         }
                                     }}
                                     type={'primary'}
                                     disabled={false}/>
                </div>
            </div>
            <div className={"row w-100 mb-2 pb-3 pt-3 pl-3 pr-3 d-flex justify-content-between"}>
                <div className={"col-md-12 "}>
                    <ol>
                        <div dangerouslySetInnerHTML={{__html: filledInPaymentInfo}}/>
                        <div dangerouslySetInnerHTML={{__html: store.translate( 'leadgeneration.steps.order.belfius.disclaimer' )}}/>
                    </ol>
                </div>
            </div>
        </div>
    </div>)
} );
